import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import CryptoAssetMHero from "./CryptoAssetMHero";
import WhyChCAMan from "./WhyChCAMan";
import CAManSolutions from "./CAManSolutions";
import MultiAssetPortfolio from "./MultiAssetPortfolio";

function CryptoAssetManagement() {
  return (
    <>
      <Header />
      <CryptoAssetMHero />
      <WhyChCAMan />
      <CAManSolutions />
      <MultiAssetPortfolio />
      <Footer />
    </>
  );
}

export default CryptoAssetManagement;
